import DM from 'DM';

export default class MicrosoftTracker {
    constructor() {
        this.name = 'microsoft';
    }

    loadScript() {
        return new Promise((resolve) => {
            if (!window.uetq) {
                (function (w, d, t, r, u) {
                    var f, n, i;
                    w[u] = w[u] || [], f = function () {
                        var o = {ti: "97074823", enableAutoSpaTracking: true};
                        o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad")
                    },
                        n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () {
                        var s = this.readyState;
                        s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null)
                    },
                        i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i)
                })
                (window, document, "script", "//bat.bing.com/bat.js", "uetq");
            }
        });
    }

    dispatch(event, payload) {
        console.log("dispatch", event, payload);
        this.loadScript().then((ttq) => {
            if (typeof (this[event]) === 'function') {
                this[event](ttq, payload);
            }
        });
    }
}
